<template>
  <div class="flex flex-col items-center">
    <img :src="require('./../assets/spamming.jpg')" alt="Limite atteinte" class="mb-6 w-72" />
    <span class="h4 mb-4">Limite de dépôt de projet atteinte</span>
    <p>
      <fa-icon type="far" icon="info-circle" />
      Pour limiter les tentatives de spam, il n'est pas possible de publier plus de
      {{ mainStore.user.dailyProjectsQuota }} projets par jour. Si vous avez besoin de publier plus de
      {{ mainStore.user.dailyProjectsQuota }} projets aujourd'hui, veuillez
      <a href="/contact" class="" target="_blank" rel="noopener">nous contacter</a>
      .
    </p>
    <button class="btn btn-primary btn-lg px-10" @click="$root.close">Fermer</button>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useMainStore } from '@/apps/fast/store'

export default {
  data() {
    return {
      confirmationState: null
    }
  },
  computed: {
    ...mapStores(useMainStore)
  }
}
</script>
